import type { RouteObject } from "react-router-dom";
import AppShell from "@/components/feature/AppShell";

const routes: RouteObject[] = [
  { path: "*", element: <AppShell /> },
];

export default routes;